/* OCP hero slider v1.0 — точки, стрелки, автолистание с паузой на наведении и в фоне.
   Отдельным файлом, а не инлайном: theme check запрещает блокирующие скрипты,
   а инлайн ломал бы CSP витрины. */
(function () {
  function init(root) {
    var slides = [].slice.call(root.querySelectorAll('[data-slide]'));
    var dots = root.querySelector('[data-dots]');
    if (slides.length < 2 || !dots) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0, timer = null;
    var seconds = parseInt(root.getAttribute('data-autoplay') || '0', 10);

    dots.innerHTML = slides.map(function (_, n) {
      return '<button class="ocp-hero__dot" type="button" role="tab" data-go="' + n +
        '" aria-current="' + (n === 0) + '" aria-label="' + (n + 1) + '"></button>';
    }).join('');

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      dots.querySelectorAll('[data-go]').forEach(function (d, k) {
        d.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
    }
    function next() { show(i + 1); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { if (!seconds || reduce) return; stop(); timer = setInterval(next, seconds * 1000); }

    dots.addEventListener('click', function (e) {
      var b = e.target.closest('[data-go]');
      if (b) { show(parseInt(b.getAttribute('data-go'), 10)); start(); }
    });
    var prev = root.querySelector('[data-prev]'), nxt = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); start(); });
    if (nxt) nxt.addEventListener('click', function () { next(); start(); });
    /* Пауза, пока читают: наведение, фокус внутри и уход со вкладки. */
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else { start(); } });

    show(0);
    start();
  }

  function boot() { document.querySelectorAll('[data-ocp-hero]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
